import network from "./network";
import { marketIntelligenceUrl, getWatchListUrl } from "./const";
import { getWatchlistCache, setWatchlistCache } from "../utils/watchlist-cache";
import {
    GET_MARKET_INTELLIGENCE,
    GET_NEWS_PAIRS,
    GET_MARKET_NEWS,
    GET_METRICS,
    GET_FILINGS,
    GET_INSIDERS,
    GET_SENTIMENT_ANALYSIS,
    SET_MARKET_INTELLIGENCE_LOADING,
    GET_SENTINENT_ASSESSMENT
} from "./types";

export const getMarketIntelligence = (pairId) => (dispatch, getState) => {
    dispatch({ type: SET_MARKET_INTELLIGENCE_LOADING, payload: true });
    return new Promise((resolve, reject) => {
        network
        .get(marketIntelligenceUrl + pairId, {}, dispatch, getState)
        .then((res) => {
            const { code, extracted_infos } = res.data;
            if (code == 200) {
                dispatch({
                    type: GET_MARKET_INTELLIGENCE,
                    payload: extracted_infos
                });
                resolve(extracted_infos);
            } else {
                dispatch({ type: SET_MARKET_INTELLIGENCE_LOADING, payload: false });
                reject();
            }
        })
        .catch((err) => {
            dispatch({ type: SET_MARKET_INTELLIGENCE_LOADING, payload: false });
            reject(err);
        });
    });
};

export const getNewsPairs = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const cachedWatchlist = getWatchlistCache();
        if (cachedWatchlist) {
            const { news_pairs } = cachedWatchlist;
            if (news_pairs) {
                dispatch({
                    type: GET_NEWS_PAIRS,
                    payload: news_pairs
                });
            }
            resolve(news_pairs);
            return;
        }

        network
        .get(getWatchListUrl, {}, dispatch, getState)
        .then((res) => {
            const { code, news_pairs, watch_list } = res.data;
            if (code == 200) {
                 // Cache both to be compatible with ai-action.js
                 setWatchlistCache({ watch_list, news_pairs });
                if (news_pairs) {
                    dispatch({
                        type: GET_NEWS_PAIRS,
                        payload: news_pairs
                    });
                }
                resolve(news_pairs);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getMarketNews = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .get("/news", {
            pair_ids: pairId,
            days: 1000
        }, dispatch, getState)
        .then((res) => {
            const { code, news_summaries } = res.data;
            if (code == 200) {
                dispatch({
                    type: GET_MARKET_NEWS,
                    payload: news_summaries
                });
                resolve(news_summaries);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getMetrics = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .get(`/metrics/${pairId}`, {}, dispatch, getState)
        .then((res) => {
            const { code, metrics, extracted_infos, data } = res.data || {};
            if (code == 200) {
                const payload = metrics || extracted_infos || data || null;
                dispatch({
                    type: GET_METRICS,
                    payload
                });
                resolve(payload);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getFilings = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .get(`/filings/${pairId}`, {}, dispatch, getState)
        .then((res) => {
            const data = res.data || {};
            const { code, message } = data;
            if (code == 200) {
                dispatch({
                    type: GET_FILINGS,
                    payload: data
                });
                resolve(data);
            } else {
                reject(message);
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getInsiders = (pairId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .get(`/insiders/${pairId}`, {}, dispatch, getState)
        .then((res) => {
            const data = res.data || {};
            const { code, message } = data;
            if (code == 200) {
                dispatch({
                    type: GET_INSIDERS,
                    payload: data
                });
                resolve(data);
            } else {
                reject(message);
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getSentimentAnalysis = (pairId, days = 30) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
        .get(`/marketpsych/${pairId}`, {
            days: days
        }, dispatch, getState)
        .then((res) => {
            const { code, extracted_infos,assessment } = res.data;
            if (code == 200) {
                if (extracted_infos) {
                    dispatch({
                        type: GET_SENTIMENT_ANALYSIS,
                        payload: extracted_infos
                    });
                }
                if (assessment) {
                    dispatch({
                        type: GET_SENTINENT_ASSESSMENT,
                        payload: assessment
                    });
                }
                resolve(extracted_infos);
            } else {
                reject();
            }
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const resetMarketIntelligence = () => (dispatch) => {
    dispatch({
        type: SET_MARKET_INTELLIGENCE_LOADING,
        payload: true
    });
    dispatch({
        type: GET_MARKET_INTELLIGENCE,
        payload: null
    });
    dispatch({
        type: GET_MARKET_NEWS,
        payload: []
    });
    dispatch({
        type: GET_METRICS,
        payload: null
    });
    dispatch({
        type: GET_FILINGS,
        payload: null
    });
    dispatch({
        type: GET_INSIDERS,
        payload: null
    });
    dispatch({
        type: GET_SENTIMENT_ANALYSIS,
        payload: []
    });
    dispatch({
        type: GET_SENTINENT_ASSESSMENT,
        payload: null
    });
};
